import { adsRoyalBlue } from "../utils/ADSColours";

const HighwayDedicationIndicator = [
  {
    id: 1,
    gpText: "PRoW",
    colour: adsRoyalBlue,
    avatar_icon: "PRoW",
    default: false,
  },
  {
    id: 2,
    gpText: "National Cycle Route",
    colour: adsRoyalBlue,
    avatar_icon: "NCR",
    default: false,
  },
  {
    id: 3,
    gpText: "Quiet route",
    colour: adsRoyalBlue,
    avatar_icon: "QuietRoute",
    default: false,
  },
  {
    id: 4,
    gpText: "Obstruction",
    colour: adsRoyalBlue,
    avatar_icon: "Obstruction",
    default: false,
  },
  {
    id: 5,
    gpText: "Planning order",
    colour: adsRoyalBlue,
    avatar_icon: "PlanningOrder",
    default: false,
  },
  {
    id: 6,
    gpText: "Works prohibited",
    colour: adsRoyalBlue,
    avatar_icon: "WorksProhibited",
    default: false,
  },
];

export default HighwayDedicationIndicator;
